import dataManager from "./data-manager";
import dashboard from "./dashboard";
import account from "./account";
import shared from "./shared";
import graph from "./graph";
import auth from "./auth";
import assistant from "./assistant";
import cate from "./cate";
import rca from "./rca";
import augmentation from "./augmentation";

const ja = {
  translation: {
    "btn-regist": "登録",
    "btn-edit": "変更",
    "btn-delete": "削除",
    "btn-back": "戻る",
    "btn-billing": "購入",
    "btn-send": "送信",
    "btn-confirm": "確認",
    "btn-regist2": "申し込む",
    "btn-card": "クレジットカード登録",
    "btn-add": "追加",
    "btn-mail": "メール",
    "btn-plan-cancel": "解約",
    "btn-leave": "退会",
    "btn-ok": "OK",

    "support-manual": "マニュアル・ダウンロード",
    "support-manual-basic": "マニュアル（因果推論ベーシック・バージョン）",
    "support-manual-advanced": "マニュアル（因果推論アドバンス・バージョン）",
    "support-whitepaper": "ホワイトペーパー・ダウンロード",
    "support-whitepaper-basic":
      "ホワイトペーパー（因果推論ベーシック・バージョン）",
    "support-whitepaper-advanced":
      "ホワイトペーパー（因果推論アドバンス・バージョン）",

    "regist-vendor-title": "企業情報登録",
    "vendor-name": "企業名",
    "vendor-postcode": "郵便番号",
    "vendor-address": "住所",
    "vendor-department": "部署名",
    "vendor-position": "役職",
    "vendor-manager": "氏名",
    "vendor-phone": "電話番号",
    "vendor-email": "メールアドレス",
    "vendor-logo": "企業ロゴ",
    "vendor-comma": "、",

    "vendor-country": "国名",
    "vendor-prefecture": "都道府県",
    "vendor-city": "市区町村",

    "vendor-plan-1-months": "1ヶ月",
    "vendor-plan-6-months": "6ヶ月",
    "vendor-plan-1-year": "1年",

    "vendor-plan-trial-light": "ライト・プラン",
    "vendor-plan-basic": "ベーシック・プラン",
    "vendor-plan-flex": "フレックス・プラン",
    "vendor-plan-multi": "マルチプロジェクト・プラン",
      
    "vendor-plan-standard": "xCausal™  Standard (スタンダード版)",
    "vendor-plan-standard-desc":
      "BIダッシュボード\n因果探索(3種類) ※追加予定\n因果推論(構造的因果モデルベース)\nSmallyticsアルゴリズム\n離散値と連続値の混在利用可\n層別化解析\n直接(NDE)・間接効果(NIE)の推定\n頑健性評価\n根本原因分析(RCA) \n条件付き平均処置効果(CATE) \nAIエージェントによるモデル修正",

    "vendor-plan-healthcare": "xCausal™  for Healthcare (ヘルスケア版)",
    "vendor-plan-healthcare-desc":
      "BIダッシュボード\n因果探索(3種類) ※追加予定\n因果推論(構造的因果モデルベース)\nSmallyticsアルゴリズム\n離散値と連続値の混在利用可\n層別化解析\n直接(NDE)・間接効果(NIE)の推定\n頑健性評価\n根本原因分析(RCA) \n条件付き平均処置効果(CATE) \nAIエージェントによるモデル修正\nヘルスケア・ダッシュボード\n論文検索機能\nCKE-LLM(因果知識抽出LLM機能・MSDマニュアル使用可)\nyou’dアプリの利用とデータ連携",

    "vendor-plan-code": "データ数課金プラン",
    "vendor-plan-code-desc":
      "基本料金 + データ数(サンプル数)による課金\n5アカウントまで基本料金に含む",

    "vendor-plan-cap": "容量課金プラン",
    "vendor-plan-cap-desc":
      "基本料金(1GBまで) + 追加データ容量(1GB単位)による課金\n5アカウントまで基本サービスに含む\nリファレンスへご協力いただける場合、初年度基本料金を15％ディスカウント",

    "vendor-plan-lite": "ライトプラン",
    "vendor-plan-lite-desc":
      "基本料金のみ(100KBまで)\n1アカウントのみ利用可能\n1週間の無料トライアル　※1週間無料期間終了後は自動課金\nご利用には審査が必要です",

    "vendor-plan-reference":
      "※リファレンスへご協力いただける場合、個別にお問い合わせください。",

    "vendor-plan-5-accounts": "・5アカウント分(管理者含む)",
    "vendor-plan-personal-codes": "・ユーザー連携用識別コード提供",
    "vendor-plan-healthcare-dashboard": "・ヘルスケアダッシュボード",
    "vendor-plan-user-health-dashboard": "・ユーザー体調ダッシュボード(個人)",
    "vendor-plan-data-upload": "・自社データアップロード連携",
    "vendor-plan-causal-basic": "・因果推論ベーシックバージョン",
    "vendor-plan-bayesian-version": " ベイジアンネットワーク版",
    "vendor-plan-10-nodes-included": " (10ノードまで利用可能) ",
    "vendor-plan-1-month-free": " １ヶ月間無料トライアル(5ノード)",
    "vendor-plan-6-month-plan": "6ヶ月プラン",
    "vendor-plan-1-year-plan": "1年プラン",
    "vendor-plan-basic-charge": "基本料金：",
    "vendor-plan-additional-fee": "追加料金：",
    "vendor-plan-150000": "150,000円",
    "vendor-plan-240000": "240,000円",
    "vendor-plan-375000": "375,000円",
    "vendor-plan-600000": "600,000円",
    "vendor-plan-per-user": "アプリユーザー毎：",
    "vendor-plan-150-month": "150円/月",
    "vendor-plan-200-month": "200円/月",
    "vendor-plan-300-month": "300円/月",
    "vendor-plan-400-month": "400円/月",
    "vendor-plan-future-release": "今後リリース予定",
    "vendor-plan-add-accounts": "アカウント追加",
    "vendor-plan-5-set": " (5アカウント)",
    "vendor-plan-sets-of-5":
      "追加アカウントは5アカウント毎に購入いただけます。",
    "vendor-plan-quantity": "数量",
    "vendor-plan-confirm-changes": "変更する",
    "vendor-plan-contract-details-title": "契約内容確認",
    "vendor-plan-contract-service": "契約サービス",
    "vendor-plan-contract-service-detail":
      "料金は契約期間分の基本料金(一括払い)とデータポイントによる月額料金(月額払い)で請求されます。",
    "vendor-plan-service-menu-basic": "サービスメニュー 基本料金",
    "vendor-plan-contract-period": "契約期間",
    "vendor-plan-basic-charge-2": "基本利用料金",
    "vendor-plan-no-change": " （変更なし）",
    "vendor-plan-total": "合計",
    "vendor-plan-monthly-code-fee": "データ数に基づく月額料金",
    "vendor-plan-monthly-cap-fee": "従量課金単価",
    "vendor-plan-monthly-usage-fee": "月額利用料金",
    "vendor-plan-monthly-code-fee-per": "1データあたりの月額",
    "vendor-plan-monthly-cap-fee-per": "10万dp(データポイント)あたり",

    "vendor-plan-service-changed": "サービス変更",
    "vendor-plan-service-change-1": "契約内容の変更を行いました。",
    "vendor-plan-service-change-2": "反映までしばらくお待ちください。",

    "vendor-plan-usage-fee": "従量課金",
    "vendor-plan-max-data-points": "最大データポイント",
    "vendor-plan-data-augmentation-fee": "データ拡張料金",
    "vendor-plan-causal-ai-fee": "コーザルAIアシスタント料金",

    "plan-desc-health-5": "・you'dアプリのユーザー統計データ利用可 (個別見積)",
    "plan-desc-opt-basic-1": "・Smallyticsによるノードの推奨",
    "plan-desc-opt-basic-2": "・ベイジアンネットワーク",
    "plan-desc-opt-basic-3": "・離散化により利用(離散値のみ) ",
    "plan-desc-opt-advance-1": "・Smallyticsによるノードの推奨",
    "plan-desc-opt-advance-2": "・ベイジアンネットワーク/SCM",
    "plan-desc-opt-advance-3": "・離散値と連続値を混在利用可",
    "plan-desc-opt-advance-4": "・自然直接効果(NDE)自然間接効果(NIE)",
    "plan-desc-opt-advance-5": "・頑健性評価",
    "plan-desc-opt-advance-6": "・論文検索機能",

    "plan-period-1-month": "月額プラン",
    "plan-period-6-month": "半年プラン",
    "plan-period-1-year": "年間プラン",
    "plan-price-table-1-1": "xCausal® システム利用料",
    "plan-price-table-1-1-1": "５アカウント分含む",
    "plan-price-table-1-1-2": "５アカウント分含む\n5000万データポイント含む",
    "plan-price-table-1-1-3": "料金（～10万dp）\n１アカウントのみ",

    "plan-price-table-1-2":
      "xCausal® システム利用料",
    "plan-price-table-2-1": "基本料金",
    "plan-price-table-2-2": "追加アカウント",
    "plan-price-table-2-3": "従量課金単価\n10万dp(データポイント)あたり\n※セル数と同義",

    "plan-expansion-desc": "データ拡張料金\nxCausal®では、作成した因果モデルから小規模なシードデータ(元データ)を大規模データに拡張する「データ拡張機能」を提供しています。\nデータ拡張機能は、システム利用料金に加えて、データ拡張を実施する度に課金が発生します。\n従量課金は、10万dp(データポイント)を単位としています。",
    "plan-expansion-title": "データ拡張料金",
    "plan-expansion-table-1-1": "データ拡張料金",
    "plan-expansion-table-1-2": "データ拡張料(データ生成)",
    "plan-expansion-table-2-1": "カテゴリー",
    "plan-expansion-table-2-2": "契約期間別プラン名称",
    "plan-expansion-table-2-3": "月数",
    "plan-expansion-table-2-4": "10万dp分1回あたり金額",

    "plan-price-table-cap-1-1-2": "容量1GB・５アカウント分含む",
    "plan-price-table-cap-2-2": "容量課金分",

    "plan-youd-option": "you’d連携\nオプション",
    "youd-content-title-1": "「",
    "youd-content-title-2": "you'd™︎",
    "youd-content-title-3": "」連携解析サービス",
    "youd-content-guide-1-1": "",
    "youd-content-guide-1-2": "you'd™︎(ユード)",
    "youd-content-guide-1-3":
      "は、ウェアラブル端末やスマートフォンに蓄積されたライフログ、ユーザー自身が入力した体調や習慣の記録、さらに天気や気圧などの環境データを掛け合わせて解析を行うコンディショニングAIアプリです。",
    "youd-content-guide-2-1": "",
    "youd-content-guide-2-2": "you'd™︎(ユード)",
    "youd-content-guide-2-3":
      "と連携し、契約者様の企業が保有する独自のデータも組み合わせることで、より高度でカスタマイズされたデータ解析が可能です。さらに精度の高い解析結果とインサイトを導き出し、ビジネスの意思決定や戦略策定に役立てていただけます。",
    "youd-contenxt-popup":
      "you'd連携オプションをご利用の場合には、ご契約時に事前のお申し込みが必要です。you'dアプリは無料でご利用いただけます。なお、契約途中でyou'd連携への切り替えはできかねます。途中切り替えの場合には、切り替え以前のデータを移行できないため、再度初期設定をおこなっていただく必要がございます。",

    "vendor-plan-monthly-cap-1": "データポイント",
    "vendor-plan-monthly-cap-2": "の時の月額換算",

    "regist-vendor-plan-custom": "上記以外のお見積・カスタム対応",
    "regist-vendor-plan-custom-desc": "コーザルAIアシスタントをご利用の際やカスタム対応が必要な場合は個別にお問い合わせください。",
    "regist-vendor-inquiry": "お問い合わせ",

    "regist-vendor-complete-title": "企業情報登録完了",
    "regist-vendor-complete-message":
      "決済処理を行っています。\n反映までしばらくお待ちください。",
    "regist-vendor-inspection-title": "企業情報確認中",
    "regist-vendor-inspection-message":
      "確認を行っています。\nしばらくお待ちください",
    "regist-vendor-ready-title": "企業情報確認完了",
    "regist-vendor-ready-message":
      "企業情報の確認が完了しました。\n支払情報の登録を行ってください。",

    "regist-vendor-select-service": "利用サービスと料金プランの選択",
    "regist-vendor-select-service-desc": "xCausal®（クロス・コーザル ) の機能\nコーザルAI(因果AI)プラットフォーム「xCausal®」では、デフォルトで以下の因果推論機能を提供しています。\n\nダッシュボード\n因果探索(複数アルゴリズム)\n因果推論(平均処置効果/層別化平均処置効果)\nSmallytics因果性変数推奨機能\n直接効果(NDE)/間接効果(NIE)推定\n頑健性評価\n根本原因分析(RCA)\n条件付き平均処置効果(CATE)\nAIエージェントと対話型UIによるアシスタント機能\nデータ拡張機能\n\n料金プランの単位「データポイント」について\nxCausal®では表形式のデータを扱います。データポイントはセル数と同義で以下の計算式で計算されます。\nデータポイントは、xCausal®では「dp」と表記することがあります。\n\nデータポイント(セル数)  =  行数 x 列数\n\nxCausal®では、100,000データポイント(dp)を従量課金分の1単位としています。\n\nシステム利用料金プラン\nシステム利用料金プランは試用目的の「ライト・プラン」、基本プランの「ベーシック・プラン」と「フレックス・プラン」、複数プロジェクトでご利用いただける「マルチプロジェクト・プラン」という4つのプランからお選びいただけます。\nそれぞれのプランにおける契約期間は3つの期間(1ヶ月・6ヶ月・１年)からお選びいただけます。\n契約期間がより長いプランほど、月額換算の金額がお安くなります。\n※契約期間内の途中解約はできず、お支払いを継続いただくことが利用条件となります。あらかじめご了承ください。\n\nライト・プラン\n基本料金のみのプランです。\n10万dp(データポイント)まで利用可能です。\n1アカウントのみでの利用となり、クレジットカードでの支払いのみ対応します。\n1週間の無償利用が可能な、試用目的の料金プランです。\n\nベーシック・プラン\n「基本料金 + 従量課金」のプランです。\n従量課金は、10万dp(データポイント)を単位としています。\n5アカウント(解析者)まで料金に含まれております。\nデータが少ない場合におすすめです。\n従量課金は毎月の利用量を集計し、月末締めでご請求いたします。\n\nフレックス・プラン\n「5,000万データポイントまで定額利用可能な基本料金 + 超過分従量課金」のプランです。\n従量課金は、10万dp(データポイント)を単位としています。\n5アカウント(解析者)まで料金に含まれております。\nデータが多い場合におすすめです。\n従量課金は毎月の利用量を集計し、月末締めでご請求いたします。\n\nマルチプロジェクト・プラン\n5プロジェクト(複数データベース)まで利用可能なマルチプロジェクトプランです。\n専用インスタンスを用意するため準備にお時間をいただきます。\n年間契約のみの提供です。ご利用時はお問い合わせください。\n\n※リファレンスへご協力いただける場合、初年度基本料金を10%ディスカウントします。\n　個別にお問い合わせください。",

    "regist-vendor-choose": "決定する",
    "regist-vendor-warnings-1":
      "xCausalはお手持ちのデータをアップロードして使えます。",
    "regist-vendor-warnings-2":
      "また、当社のコンディショニングアプリ「you’d」を利用してライフログ取得・連携する事も可能です。",
    "regist-vendor-warnings-3": "その場合の連携フローが下記のようになります。",

    "regist-vendor-alt-1": "個人・医療・クラウドの繋がり",
    "regist-vendor-step": "ステップ",
    "regist-vendor-flow-0":
      "xCausal™のサービスをご利用する際には、まずWebで必要事項の登録を行いアカウントを開設します。",
    "regist-vendor-flow-1":
      "xCausal™のポータルサイト上で発行される識別コードを取得し、自社の個人ユーザー(または患者)へ配布いただく準備を行います。入手した識別コードと、メールアドレス等の自社で持っているユーザー情報を紐付けて管理します。",
    "regist-vendor-flow-2":
      "識別コードを自社の個人ユーザーへメールにて配布します。この際、十分なユーザー数と網羅的にデータを確保することがポイントです。解析対象となるデータ項目全てについて記録があるユーザーが、30名以上いることを推奨しています。",
    "regist-vendor-flow-3":
      "識別コードを受け取ったユーザーは、当社のパーソナルコンディショニングアプリyou’d™(またはyou’d™のOEMアプリ)を通じて、データのやり取りを行うため、まずアプリをダウンロードいただきます。(「you’d」で検索ください。)",
    "regist-vendor-flow-4":
      "識別コードを受け取ったユーザーは、you'd™アプリ上で表示される識別コード入力画面で識別コードを入力し、自分のヘルスデータやライフログの提供と送り元の企業や医療機関にあるデータとの連携について、アプリ画面上で承諾します。",
    "regist-vendor-flow-5":
      "承諾後、you'd™アプリで取得された個人ユーザーのデータは、クラウドにアップロードされます。",
    "regist-vendor-flow-6":
      "自社にあるデータをxCausal™ポータルサイトのデータ連携ページからcsv形式でアップロードします。",
    "regist-vendor-flow-7":
      "識別コードで連携します。(個人情報はご提供いただかない仕組みです)データ連携後は、匿名化され統計化された状態でxCausal™サービスをご利用いただきます。ご利用可能なデータは、ユーザーのスマートフォン上のiOS™のヘルスケアや、Android ™版がリリースされた際はGoogleFitにあるヘルスデータ、および「you'd™」でユーザーが入力した体調、不調症状、習慣に関するデータです。ユーザー数が少ない項目に関しては、人数とデータが十分に揃った段階で表示されます。",
    "regist-vendor-flow-9":
      "自社の個人ユーザーや新規個人ユーザーに向けた商品・サービス開発、オンライン診療、IoTサービスなどへご利用いただけます。",
    "regist-vendor-logo-skip": "後でアップロードする",

    PLAN_ID_PLUGIN_1M: "ウェルネス・プラン (一般企業向け)",
    PLAN_ID_PLUGIN_6M: "ウェルネス・プラン (一般企業向け)",
    PLAN_ID_PLUGIN_1Y: "ウェルネス・プラン (一般企業向け)",
    PLAN_ID_MEDICAL_1M: "メディカルアシスト・プラン (医師・医療機関向け)",
    PLAN_ID_MEDICAL_6M: "メディカルアシスト・プラン (医師・医療機関向け)",
    PLAN_ID_MEDICAL_1Y: "メディカルアシスト・プラン (医師・医療機関向け)",
    PLAN_ID_DE_BASIC_1M: "因果推論ベーシック・バージョン",
    PLAN_ID_DE_BASIC_6M: "因果推論ベーシック・バージョン",
    PLAN_ID_DE_BASIC_1Y: "因果推論ベーシック・バージョン",
    PLAN_ID_DE_ADVANCED_1M: " 因果推論アドバンス・バージョン",
    PLAN_ID_DE_ADVANCED_6M: " 因果推論アドバンス・バージョン",
    PLAN_ID_DE_ADVANCED_1Y: " 因果推論アドバンス・バージョン",

    PLAN_ID_CODE_BASIC_1M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_BASIC_6M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_BASIC_12M: " データ数課金プラン ベーシック・バージョン",
    PLAN_ID_CODE_ADVANCED_1M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CODE_ADVANCED_6M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CODE_ADVANCED_12M: " データ数課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_BASIC_1M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_BASIC_6M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_BASIC_12M: " 容量課金プラン ベーシック・バージョン",
    PLAN_ID_CAP_ADVANCED_1M: " 容量課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_ADVANCED_6M: " 容量課金プラン アドバンス・バージョン",
    PLAN_ID_CAP_ADVANCED_12M: " 容量課金プラン アドバンス・バージョン",

    PLAN_ID_CODE_STANDARD_1M:
      "xCausal™  Standard (スタンダード版) データ数課金プラン",
    PLAN_ID_CODE_STANDARD_6M:
      "xCausal™  Standard (スタンダード版) データ数課金プラン",
    PLAN_ID_CODE_STANDARD_12M:
      "xCausal™  Standard (スタンダード版) データ数課金プラン",
    PLAN_ID_CAP_STANDARD_1M:
      "xCausal™  Standard (スタンダード版) 容量課金プラン",
    PLAN_ID_CAP_STANDARD_6M:
      "xCausal™  Standard (スタンダード版) 容量課金プラン",
    PLAN_ID_CAP_STANDARD_12M:
      "xCausal™  Standard (スタンダード版) 容量課金プラン",
    PLAN_ID_CODE_HEALTHCARE_1M:
      "xCausal™  for Healthcare (ヘルスケア版) データ数課金プラン",
    PLAN_ID_CODE_HEALTHCARE_6M:
      "xCausal™  for Healthcare (ヘルスケア版) データ数課金プラン",
    PLAN_ID_CODE_HEALTHCARE_12M:
      "xCausal™  for Healthcare (ヘルスケア版) データ数課金プラン",
    PLAN_ID_CAP_HEALTHCARE_1M:
      "xCausal™  for Healthcare (ヘルスケア版) 容量課金プラン",
    PLAN_ID_CAP_HEALTHCARE_6M:
      "xCausal™  for Healthcare (ヘルスケア版) 容量課金プラン",
    PLAN_ID_CAP_HEALTHCARE_12M:
      "xCausal™  for Healthcare (ヘルスケア版) 容量課金プラン",

    PLAN_ID_LIGHT_1M:
      'xCausal™  Standard (スタンダード版) ライトプラン',
    PLAN_ID_LIGHT_6M:
      'xCausal™  Standard (スタンダード版) ライトプラン',
    PLAN_ID_LIGHT_12M:
      'xCausal™  Standard (スタンダード版) ライトプラン',

    PLAN_ID_TRIAL_LIGHT:
      'xCausal® ライト・プラン',
    PLAN_ID_BASIC_1M:
      'xCausal®  ベーシック・プラン',
    PLAN_ID_BASIC_6M:
      'xCausal®  ベーシック・プラン',
    PLAN_ID_BASIC_12M:
      'xCausal®  ベーシック・プラン',
    PLAN_ID_FLEX_1M:
      'xCausal®  フレックス・プラン',
    PLAN_ID_FLEX_6M:
      'xCausal®  フレックス・プラン',
    PLAN_ID_FLEX_12M:
      'xCausal®  フレックス・プラン',

    "corporate-health-file": "ファイルを選択してください",

    "set-unit": "単位設定",
    "unit-name": "単位名",
    "decimal-places": "小数点の桁数",
    "data-type": "欠損補完のタイプ",
    "display-in-user-app": "ユーザーアプリ表示",
    "vital-data-type": "線形補完（連続データ等）",
    "event-data-type": "ゼロ補完（イベントデータ等）",
    "update-settings": "設定を反映する",

    "error-empty-columns": "を入力してください。",

    "app-discret-title": "3.【因果推論データ設定】",
    "app-discret-desc-2":
      "最初に離散化レベル値を設定し、手動の場合は各レベルの境界となる値を決定します。\n因果階層設定では、同じ層、数字の大きな層への因果のみを許可します。",
    "app-discret-desc-4":
      "※「設定を行う」ボタンをクリックし、各データ項目を設定して「設定を反映する」をボタンをクリックしてください。",

    "app-discret-update-button": "設定を反映する",
    "app-discret-unavailable-message":
      "{{names}}は、データの偏りが大きいため離散化できません。CSVから除外して再度アップロードしてください。\nなお、CSVには4識別コード以上かつ20サンプル以上を含める必要があります。",
    "app-discret-selection": "選択",
    "app-discret-upload": "データ項目",
    "app-discret-levels": "離散化レベル数",
    "app-discret-range": "離散範囲設定",
    "app-discret-remove-outliers": "外れ値の削除",
    "app-discret-level-settings": "因果階層設定",
    "app-discret-boundary-values": "離散化レベル境界値の設定",
    "app-discret-auto": "自動",
    "app-discret-manual": "手動",
    "app-discret-on": "オン",
    "app-discret-off": "オフ",
    "app-discret-update-display": "表示更新",

    "node-table-ranking-label": "関連順位",
    "node-table-item-name": "項目名",
    "node-table-item-layer": "因果階層",
    "node-table-number-of-people": "識別コード数",
    "node-table-number-of-record": "総レコード数",

    "demo-graph-male": "男性",
    "demo-graph-female": "女性",

    "trial-popup-1":
      "1週間の無料トライアル期間中は請求が発生することはございません。",
    "trial-popup-2":
      "※無料トライアル終了後、自動更新となりますのでご注意ください。",
    "trial-popup-3":
      "ライトプランのご利用には審査が必要です。",

    "error-auth": "認証エラーが発生しました。再度ログインしてください。",
    "error-within7days": "現在、7日以内のデータは解析できません。",
    "error-invalidValue": "無効な数値です。",
    "error-exceedMaxValue": "最大値を超えています。",
    "error-noOutcomeNode": "アウトカムノードを選択してください。",
    "error-noRelevanceNode": "関連ノードを選択してください。",
    "error-noData":
      "この条件ではデータがありません。他の条件で試してください。",
    "error-exceedMaxNumberOfNodes1": "最大",
    "error-exceedMaxNumberOfNodes2": "個まで選択できます。",
    "error-api-unknown":
      "サーバーからデータをロード中にエラーが発生しました。 後でもう一度やり直してください。",

    // NEW ERROR
    "error-check-username-and-password":
      "ユーザネームまたはパスワードをもういちど確認してください",
    "communication-error": "通信エラー",
    "error-reenter-code": "コードを再度入力してください",
    "error-enter-code": "コードを入力してください",
    "error-no-service-contract": "サービス契約されていません",
    "error-not-enough-items": "項目が足りません",
    "error-no-data": "データがありません",
    "error-datetime-out-of-range": "範囲外の日時データがあります",
    "error-personal-code-user-not-found":
      "識別コードに紐づくユーザーが見つかりません",
    "upload-error": "アップロードエラー",
    "ten-items-error": "アプリに表示できるのは最大10項目です",
    "error-incorrect-value-entered": "入力された値が正しくありません",
    "error-no-data-uploaded": "アップロードされたデータがありません",
    "error-failed-update-settings": "設定の更新に失敗しました",
    "error-failed-get-data": "データの取得に失敗しました",
    "error-incorrect-value-set": "設定された値が正しくありません",
    "error-check-with-doctor": "医師の確認を行ってください",
    "error-member-info-not-confirmed": "メンバー情報が確認できませんでした。",
    "error-select-plan": "プランを選択してください",
    "error-logo-size-too-large": "企業ロゴのサイズが大きすぎます",
    "error-select-option": "オプションプランを選択してください",
    "error-invalid-additional-account": "追加アカウントが不正です。",

    // COMMON
    "common-confirm": "確定",
    "common-change-name": "名称変更",
    "common-delete": "削除",
    "common-quarter-day": "1/4日",
    "common-one-day": "1日",
    "common-one-week": "1週",
    "common-one-month": "1ヶ月",
    "common-day": "日",
    "common-week": "週",
    "common-month": "月",

    "common-genders-label": "性別",
    "common-male-label": "男性",
    "common-female-label": "女性",
    "common-other-label": "その他",
    "common-age-label": "年代",
    "common-ages-label": "年代",
    "common-address-label": "地域",
    "common-days-label": "日",
    "common-weeks-label": "週",
    "common-months-label": "ヶ月",
    "common-people-label": "人",
    "common-basic-information-label": "基本情報",
    "common-whole-body-label": "全体",
    "common-whole-body-body-label": "体全体",
    "common-condition-label": "体調",
    "common-worrisome-symptoms-label": "気になる不調症状",
    "common-location-label": "部位",
    "common-very-good-label": "とても良い",
    "common-good-label": "良い",
    "common-ok-label": "まあまあ",
    "common-bad-label": "悪い",
    "common-very-bad-label": "とても悪い",

    "common-error-message": "エラーのため表示できません",

    "current-level": "現状",

    // TOP BAR
    "topbar-all-groups-label": "全てのグループ",
    "topbar-all-addresses-label": "全ての地域",
    "topbar-all-ages-label": "全ての年代",
    "topbar-no-upper-limit-label": "上限なし",
    "topbar-filtering-label": "母集団絞り込み",
    "topbar-filter-conditions-label": "絞り込み条件",
    "topbar-number-cases-label": "該当件数",
    "topbar-from-label": "いつから",
    "topbar-to-label": "いつまで",

    ...dataManager,
    ...dashboard,
    ...account,
    ...shared,
    ...graph,
    ...auth,
    ...assistant,
    ...cate,
    ...rca,
    ...augmentation,
  },
};

export default ja;
